// extracted by mini-css-extract-plugin
export var completionBody = "_lb-2";
export var completionCard = "_lb-0";
export var completionFooter = "_lb-3";
export var completionTitle = "_lb-1";